module.exports = __webpack_public_path__ + "img/video906.47acd370.jpg";